document.addEventListener('DOMContentLoaded', function() {
  function initializeFlyoutMenus() {
    const submenus = document.querySelectorAll('.header__submenu.list-menu');
    submenus.forEach(submenu => {
      submenu.classList.add('onhow-submenu');
    });

    const navItems = document.querySelectorAll('.header__inline-menu .header__menu-item');
    navItems.forEach(item => {
      item.classList.add('onhow-nav-item');
    });

    const menuItemsWithSubmenus = document.querySelectorAll('.header__submenu details');

    menuItemsWithSubmenus.forEach(menuItem => {
      menuItem.classList.add('onhow-submenu-parent');

      const childSubmenu = menuItem.querySelector('.header__submenu');
      if (childSubmenu) {
        childSubmenu.classList.add('onhow-flyout-submenu');
      }
    });

    setupMenuClosingBehavior();
  }

  function setupMenuClosingBehavior() {
    const firstLevelDetails = document.querySelectorAll('.header__inline-menu > ul > li > details');

    firstLevelDetails.forEach(detail => {
      detail.addEventListener('click', function(event) {
        if (event.target.closest('summary')) {
          firstLevelDetails.forEach(otherDetail => {
            if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
              otherDetail.removeAttribute('open');
            }
          });
        }
      });
    });

    const flyoutDetails = document.querySelectorAll('.onhow-submenu-parent');

    flyoutDetails.forEach(detail => {
      detail.addEventListener('click', function(event) {
        if (event.target.closest('summary')) {
          event.stopPropagation();

          const parentSubmenu = detail.closest('.onhow-submenu');

          if (parentSubmenu) {
            const siblingFlyouts = parentSubmenu.querySelectorAll('.onhow-submenu-parent');
            siblingFlyouts.forEach(otherDetail => {
              if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
                otherDetail.removeAttribute('open');
              }
            });
          }
        }
      });
    });

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.header__inline-menu')) {
        const allDetails = document.querySelectorAll('.header__inline-menu details[open]');
        allDetails.forEach(detail => {
          detail.removeAttribute('open');
        });
      }
    });

    firstLevelDetails.forEach(detail => {
      detail.addEventListener('toggle', function() {
        if (!this.hasAttribute('open')) {
          const nestedFlyouts = this.querySelectorAll('.onhow-submenu-parent[open]');
          nestedFlyouts.forEach(flyout => {
            flyout.removeAttribute('open');
          });
        }
      });
    });
  }

  initializeFlyoutMenus();
  setTimeout(initializeFlyoutMenus, 500);
});
